import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TablasService {
  constructor(private http: HttpClient) {}

  public getValoresTablas(prefijo: string, token: string, select: string[], orden:  string[]): Promise<Tabla[]> {
    let url: string = environment.tablasWSBase + "/Tablas/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
      {
        "parameters":
          [[{
            campo: "prefix",
            operacion: "=",
            valor: prefijo
          }]],
        select: select,
        orden: [orden]
      };

    return new Promise<Tabla[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });

  }

  public getTalleresExcluidos(piloto: string, token: string){
    let url: string = environment.tablasWSBase + "/Tablas/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
      {
        "parameters":
          [
            [
              {
                campo: "prefix",
                operacion: "=",
                valor: "PT"
              }
            ],
            [
              {
                campo: "codi",
                operacion: "=",
                valor: piloto
              }
            ]
          ],
        select: ["dades"]
      };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public personalizarTablas(array: any, token: string){
    let url: string = environment.tablasWSBase + "/Tablas/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,array,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  /**
   * Obtiene los valores de tablas pero de codis concretos 
   * @param prefijo El prefijo de la tabla.
   * @param token El token de autenticación.
   * @param select Los campos a seleccionar.
   * @param orden El orden de los resultados.
   * @param codi Los códigos específicos para filtrar.
   * @returns Una promesa que resuelve con un array de objetos Tabla.
   */
  public getValoresTablasConcretos(prefijo: string, token: string, select: string[], orden:  string[],codi:string[]): Promise<Tabla[]> 
  {
    let url: string = environment.tablasWSBase + "/Tablas/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
    {
      "parameters":
        [[{
          campo: "prefix",
          operacion: "=",
          valor: prefijo
        }],
        [{
          campo: "codi",
          operacion: "IN",
          valor:"",
          valor2: codi
        }]],
      select: select,
      orden: [orden]
    };

    return new Promise<Tabla[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }
}

export interface Tabla
{
  codi: string;
  descripcio: string;
  dades: string;
}
